<template>
    <div class="about-page">
        <div class="page-header-block">
            <img :src="headerImage" v-if="channelWidth>768"/>
            <img v-else :src="headerPhoneImage"/>
        </div>
        <div class="page-content">
            <div class="content-block first">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                    <div class="show-profile">
                        <title-block :list-index="'4'" style="font-size: 16px;margin-bottom: 30px"></title-block>
                        <div class="info" style="line-height: 26px;text-indent:28px">江苏劲步科技有限公司成立于2020年，注册资本1000万元，办公地址在江苏省南京市雨花台区安德门大街32号紫悦广场东大楼01幢401室。公司主要经营软件设计、开发、销售及技术支持、技术服务、技术培训；物联网相关产品的设计、研发、销售；互联网信息服务；电子产品开发与销售。
                            公司现有员工10余人，拥有“智慧工地测试项目登录平台软件”“智慧商业运营平台软件”“智慧商城系统软件”等软件著作权8项。公司积极开拓智慧城市、智慧社区、智慧公共事业、智慧农业、智慧消防、电力泛在物联网、油田物联网等各政府职能机构及行业物联网市场。目前已经具备多种行业解决方案的交付能力。    公司密切协同各省公司及专业公司，以开放、合作、共享的发展理念，广泛开展企业合作，以市场化机制独立运作，力争成为物联网领先企业，推动物联网在各行业的规模应用！
                        </div>
                    </div>
                    <img :src="showInfoImage"/>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>
            <div class="content-block second">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                    <div class="icon-list">
<!--                        <div class="icon-item" v-for="item in iconList">-->
                            <div class="icon-info">
                                <img :src="iconList[0].icon"/>
                                <div class="name">{{iconList[0].name}}</div>
                                <div>{{iconList[0].info}}</div>
                            </div>
                            <div class="line"></div>
                        <div class="icon-info">
                            <img :src="iconList[1].icon"/>
                            <div class="name">{{iconList[1].name}}</div>
                            <div>{{iconList[1].info}}</div>
                        </div>
                        <div class="line"></div>
                        <div class="icon-info">
                            <img :src="iconList[2].icon"/>
                            <div class="name">{{iconList[2].name}}</div>
                            <div>{{iconList[2].info}}</div>
                        </div>
                        <div class="line"></div>
                        <div class="icon-info">
                            <img :src="iconList[3].icon"/>
                            <div class="name">{{iconList[3].name}}</div>
                            <div>{{iconList[3].info}}</div>
                        </div>
<!--                        </div>-->
                    </div>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>

            <div class="content-block" style="background: #FFFFFF;">
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col class="content-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                    <div class="honor-body">
                        <title-block :list-index="'5'" style="font-size: 16px;"></title-block>

                        <div class="writings-title" style="margin-top: 20px;font-size: 18px">软件著作</div>
                        <div class="image-list">
                            <swiper :options="swiperOption">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in writingsList">
                                    <div class="image-swiper">
                                        <img width="80%" :src="item" @click.stop="showImg(item)"/>
                                    </div>
                                </swiper-slide>
                            </swiper>
<!--                            <img v-for="item in writingsList" :src="item"/>-->
                        </div>
                        <div class="writings-title" style="margin-top: 20px;font-size: 18px">企业资质</div>
                        <div class="image-list">
                            <swiper :options="swiperOption">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in honorList">
                                    <div class="image-swiper" >
                                        <img width="80%" :src="item" @click.stop="showImg(item)"/>
                                    </div>
                                </swiper-slide>
                            </swiper>
<!--                            <div class="button-next"-->
<!--                                 style="outline: none;position: absolute;z-index: 1000;top: 50%;right:20px;transform: translate(0,-50%);cursor: pointer">-->
<!--                                <i class="el-icon-arrow-right"-->
<!--                                   style="color: white;font-size: 40px;display: flex;justify-content: center;align-items: center;line-height: 60px;font-weight: bold"></i>-->
<!--                            </div>-->
                        </div>
                    </div>
                </el-col>
                <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            </div>

        </div>
        <div class="image-block" v-show="showimage" @click="showimage = false">
            <img :src="chooseImage"/>
        </div>
    </div>
</template>

<script>
    import HeaderImage from '../../image/about/about_header.png'
    import HeaderPhoneImage from '../../image/about/about_phone_header.png'
    import ShowInfoImage from '../../image/about/about_info.png'
    import Icon1 from '../../image/about/about_icon_1.png'
    import Icon2 from '../../image/about/about_icon_2.png'
    import Icon3 from '../../image/about/about_icon_3.png'
    import Icon4 from '../../image/about/about_icon_4.png'
    import HonorImg1 from '../../image/about/honor_img1.png'
    import HonorImg2 from '../../image/about/honor_img2.png'
    import HonorImg3 from '../../image/about/honor_img3.png'
    import HonorImg4 from '../../image/about/honor_img4.png'
    import HonorImg5 from '../../image/about/honor_img5.png'
    import HonorImg6 from '../../image/about/honor_img6.png'
    import HonorImg7 from '../../image/about/honor_img7.png'
    import WritingsImg1 from '../../image/about/writings_img1.png'
    import WritingsImg2 from '../../image/about/writings_img2.png'
    import WritingsImg3 from '../../image/about/writings_img3.png'
    import WritingsImg4 from '../../image/about/writings_img4.png'
    import WritingsImg5 from '../../image/about/writings_img5.png'
    import WritingsImg7 from '../../image/about/writings_img7.png'
    import WritingsImg8 from '../../image/about/writings_img8.png'
    import WritingsImg9 from '../../image/about/writings_img9.png'
    import WritingsImg6 from '../../image/about/writings_img6.png'
    import WritingsImg10 from '../../image/about/writings_img10.png'
    import WritingsImg11 from '../../image/about/writings_img11.png'
    import WritingsImg12 from '../../image/about/writings_img12.png'
    import WritingsImg13 from '../../image/about/writings_img13.png'
    import WritingsImg14 from '../../image/about/writings_img14.png'

    //组件引入
    import TitleBlock from '../../../components/home-page-title-block/home-page-title-block'
    export default {
        name: "about-page",
        components:{
            TitleBlock
        },
        data(){
            return{
                channelWidth: null,      //浏览器窗口宽度
                headerImage:HeaderImage,
                headerPhoneImage:HeaderPhoneImage,
                showInfoImage:ShowInfoImage,
                chooseImage:'',
                showimage:false,
                iconList:[
                    {name:'质量保证',icon:Icon1,info:'项目质量既是服务质量'},
                    {name:'平台安全',icon:Icon4,info:'自主研发的统一虚拟化平台'},
                    {name:'数据保证',icon:Icon2,info:'安全地保存或转移您的数据 '},
                    {name:'产品支持',icon:Icon3,info:'及时响应您的问题或者建议'},
                ],
                honorList:[HonorImg1,HonorImg2,HonorImg3,HonorImg4,HonorImg5,HonorImg6,HonorImg7],
                writingsList:[WritingsImg1,WritingsImg2,WritingsImg3,WritingsImg4,WritingsImg5,WritingsImg7,WritingsImg8,WritingsImg9,WritingsImg6,WritingsImg10,
                    WritingsImg11,WritingsImg12,WritingsImg13,WritingsImg14],
                swiperOption: {
                    slidesPerView: 4,
                    //自动轮播
                    autoplay: {
                        delay: 2000,
                        //当用户滑动图片后继续自动轮播
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.button-next',
                        prevEl: '.button-prev',
                    },
                    //开启循环模式
                    loop: true
                },
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            },

        },
        mounted(){

            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
            // console.log(this.channelWidth);
            window.addEventListener('scroll',this.handleScroll)
        },
        methods:{
            showImg(item){
                this.showimage = !this.showimage
                this.chooseImage = item
            }
        }
    }
</script>

<style lang="scss" src="./about-page.scss" scoped>

</style>
